import { ACTION_TYPES } from '../../constants';

// eslint-disable-next-line import/prefer-default-export
export const setCurrentCoords = (coords) => {
  return (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_CURR_COORDS, payload: coords });
  };
};
